var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.49 5.83a.375.375 0 00-.15-.652l-.592-.15a.375.375 0 01-.248-.525l.33-.668a.376.376 0 00-.435-.525l-1.5.42a.375.375 0 01-.33-.06 3.75 3.75 0 00-6 3v.27a.187.187 0 01-.165.188c-2.107.247-4.125-.825-6.3-3.33a.383.383 0 00-.382-.113A.375.375 0 002.5 4a5.685 5.685 0 00.345 3.69.187.187 0 01-.195.27l-.84-.165a.375.375 0 00-.427.443 3.863 3.863 0 001.777 2.835.187.187 0 010 .337l-.397.158a.374.374 0 00-.195.517 3.27 3.27 0 002.4 1.86.187.187 0 010 .353 8.207 8.207 0 01-3.218.622.382.382 0 10-.15.75c1.91.906 3.991 1.4 6.105 1.448a9.436 9.436 0 005.25-1.5 9.376 9.376 0 004.17-7.823v-.652a.374.374 0 01.135-.285l1.23-1.028z",
    fill: "#fff"
  })));
}

export default SvgTwitterinline;